
import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import './menu.css';
import { Link } from "react-router-dom";
import { store } from "../../redux/store";
import history from "../../auth/history";
import { setAepsSection } from "../../redux/aeps/aeps.action";
import tokenErrorHandler from "../tokenErrorHandler";
import { setAepsShow, setBillPayShow, setDMTShow, setKycShow, setRechargeShow, setRetailerBalanceVal } from "../../redux/misc-data/misc-data.action";
import menuShow from "./menuShow";

const httpClient = axios.create();

class Menu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            password: '',
            otpRef: '',
            message: '',
            retailerBalance: 0,
            dmtShow: this.props.dmtShow,
            billPayShow: this.props.billPayShow,
            rechargeShow: this.props.rechargeShow,
        }
    }

    componentDidMount() {

        this.loadMenu();
        setInterval(() => {
            this.loadMenu();
        }, 10000);


    }
    componentWillUnmount() {
    }

    loadMenu() {
        var menus = menuShow.getMenu();
        var menuVal = this.props.menuVal;
        if(menuVal=='true:all'){

            this.setState({
                dmtShow: menus.dmtShow
            })
    
            if (menus.dmtShow != this.props.dmtShow) {
                store.dispatch(setDMTShow(menus.dmtShow))
            }
    
            this.setState({
                billPayShow: menus.billPayShow
            })
    
            if (menus.billPayShow != this.props.billPayShow) {
                store.dispatch(setBillPayShow(menus.billPayShow))
            }
    
            this.setState({
                rechargeShow: menus.rechargeShow
            })
    
            if (menus.rechargeShow != this.props.rechargeShow) {
                store.dispatch(setRechargeShow(menus.rechargeShow))
            }
        }
        if(menuVal.includes('false')){
            var service=menuVal.split(":")[1];
            if(service==''||service=='dmt'){
                this.setState({
                    dmtShow: menus.dmtShow
                })
        
                if (menus.dmtShow != this.props.dmtShow) {
                    store.dispatch(setDMTShow(menus.dmtShow))
                }
            }
            if(service=='billpay'){
                this.setState({
                    billPayShow: menus.billPayShow
                })
        
                if (menus.billPayShow != this.props.billPayShow) {
                    store.dispatch(setBillPayShow(menus.billPayShow))
                }
            }
            if(service=='mobile'||service=='recharge'||service=='dth'){
                this.setState({
                    rechargeShow: menus.rechargeShow
                })
        
                if (menus.rechargeShow != this.props.rechargeShow) {
                    store.dispatch(setRechargeShow(menus.rechargeShow))
                }
            }
        }
    }


    goToAccountHistory = () => {
        var goToAccountHistory = document.getElementById('goToAccountHistory');
        goToAccountHistory.click();
    }


    render() {


        return (


            <div class="menu">
                <Link to='/account-history'>
                    <button id='goToAccountHistory' hidden={true}></button>
                </Link>
                <ul>
                    {this.state.dmtShow == 'yes' &&
                        <li class={this.props.selectedMenuItem == 'dashBoard' && 'active'}>
                            <Link to='/dmt'>
                                <button type="button"><i class="bank"></i> Money Transfer</button>
                            </Link>

                        </li>
                    }
                    {this.state.billPayShow == 'yes' &&
                        <li class={this.props.selectedMenuItem == 'billPay' && 'active'}>
                            <Link to='/billpay'>
                                <button type="button" ><i class="bbps"></i> Bill Payment</button>
                            </Link>
                        </li>
                    }
                    {this.state.rechargeShow == 'yes' &&
                        <li class={this.props.selectedMenuItem == 'recharge' && 'active'}>
                            <Link to='/recharge'>
                                <button type="button" ><i class="recharge"></i> Recharge</button>
                            </Link>
                        </li>
                    }

                    {this.props.aepsShow == 'yes' &&
                        <li class={this.props.selectedMenuItem == 'aeps' && 'active'}>

                            <button type="button" onClick={this.goToAeps} ><i class="aeps"></i> AePS</button>

                        </li>
                    }

                    <Link to='/aeps'>
                        <button id='gotoAepsBtn' hidden={true} ></button>
                    </Link>
                </ul>

            </div>
        );
    }
}

const mapStateToProps = ({ errorMessageReduce: { errorMessage, loginErrorMessage },
    miscReduce: { phone, agentInfo, token, loginTime, partner,
        logoName, retailerBalanceShow,
        menuVal,
        billPayShow,
        rechargeShow,
        aepsShow,
        dmtShow,
        payoutShow,
        kycShow }
    , authReduce: { callBackUrl } }
) => ({
    errorMessage, loginErrorMessage, phone, agentInfo, token, loginTime, partner,
    logoName,
    retailerBalanceShow,
    billPayShow,
    rechargeShow,
    aepsShow,
    dmtShow,
    payoutShow,
    kycShow,
    menuVal,
    callBackUrl
});

export default connect(mapStateToProps, null)(Menu);